export default "__VITE_ASSET__CyFtO38d__"